import { render, staticRenderFns } from "./namihira_church.vue?vue&type=template&id=3a57ba44&scoped=true&"
import script from "./namihira_church.vue?vue&type=script&lang=js&"
export * from "./namihira_church.vue?vue&type=script&lang=js&"
import style0 from "./namihira_church.vue?vue&type=style&index=0&id=3a57ba44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57ba44",
  null
  
)

export default component.exports